import { useState } from "react";
import * as turf from "@turf/turf";

export function useRegionFinder() {
  const [region, setRegion] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const geojsonPath = "/geojson/regions_administratives.geojson";

  const findRegion = async (latitude, longitude) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch(geojsonPath);
      if (!response.ok) {
        throw new Error("Erreur lors du chargement du fichier GeoJSON");
      }
      const geojson = await response.json();
      const userPoint = turf.point([longitude, latitude]);

      for (const feature of geojson.features) {
        if (turf.booleanPointInPolygon(userPoint, feature)) {
          setRegion(feature.properties);
          setLoading(false);
          return feature.properties;
        }
      }

      setRegion(null);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  return { region, findRegion, loading, error };
}
